import { inject, Injectable } from '@angular/core';
import { CMS_PAGE_ROUTE_CONTEXT, CmsPageRouteContext } from '../cms-page-route-context';

@Injectable({ providedIn: 'root' })
export class OrderHistoryNavigationService {
  private readonly routeContext: CmsPageRouteContext | null = inject(CMS_PAGE_ROUTE_CONTEXT, { optional: true });

  public orderLink(orderId: string): string {
    const encodedOrderId: string = encodeURIComponent(orderId);
    const legacyOrderPath: string = `order/${encodedOrderId}`;

    return this.routeContext
      ? `${this.routeContext.basePath}/${encodedOrderId}`
      : legacyOrderPath;
  }
}
